import React, { useEffect, useState } from "react";
import Axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import { NODE_HOST_URL } from "./api/Api";
import { handleUserLog } from "../Utils/Utils";

const LiveChatReport = () => {
  const [chatData, setChatData] = useState([]);
  const [brandNumber, setBrandNumber] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchWhatsappNumber();
  }, []);

  const fetchWhatsappNumber = async () => {
    setLoading(true);
    try {
      const lStorage = JSON.parse(localStorage.getItem("login"));
      const userId = lStorage.user.userId;
      const userToken = lStorage.token;

      const response = await Axios.post(
        "https://console.authkey.io/api/wp_profile.php",
        {
          user_id: userId,
          token: userToken,
          method: "retrieve",
        }
      );

      if (response.data.success && response.data.data?.length > 0) {
        const number = response.data.data[0].brand_number || "";
        setBrandNumber(number);
        fetchChatReport(userId, userToken, number);
      } else {
        setError("Brand number not found.");
        setLoading(false);
      }
    } catch (err) {
      setError("Error fetching WhatsApp number.");
      setLoading(false);
    }
  };

  const fetchChatReport = async (userId, userToken, brandNo) => {
    try {
      const payload = {
        user_id: userId,
        token: userToken,
        method: "today_report",
        brand_number: brandNo,
        user_type: "admin",
        agent_id: userId,
      };

      const response = await Axios.post(
        `${NODE_HOST_URL}/whatsapp_report`,
        payload
      );

      if (response.data.success) {
        const chats = response.data.data?.total_chat || [];
        setChatData(
          chats
            .sort((a, b) => new Date(b.created) - new Date(a.created))
            .slice(0, 2)
        );
      } else {
        setError(response.data.message || "Failed to load chat report.");
      }
    } catch (err) {
      setError("Error fetching chat report.");
    } finally {
      setLoading(false);
    }
  };

  // Improved dynamic domain resolver
  const getAuthkeyDomain = () => {
    const savedDomain = localStorage.getItem("wp-cmpy-domain");
    if (savedDomain) return savedDomain;

    const hostname = window.location.hostname; // e.g. whatsapp.adznetworkmedia.om

    const parts = hostname.split(".");
    if (parts.length <= 2) {
      // Already base domain like authkey.io or adznetworkmedia.om
      return hostname;
    }

    // Return last two parts joined (base domain + TLD)
    return parts.slice(parts.length - 2).join(".");
  };

  const goToAgentDashboard = () => {
    const loginData = localStorage.getItem("login");
    if (!loginData || !brandNumber) return;

    const { token, user } = JSON.parse(loginData);
    const userData = {
      data: {
        permission: '{ "add": 1, "update": 1, "delete": 1 }',
        success: true,
        user_type: "admin",
        brand_number: brandNumber,
        user_id: user.userId,
        parent_id: user.userId,
        parent_token: token,
        name: user.name,
        email: user.username,
        token: token,
        mobile: user.mobile,
        authkey_parent: user.authkey_parent,
      },
    };

    const encodedUserData = encodeURIComponent(JSON.stringify(userData));
    const domain = getAuthkeyDomain();
    window.open(`https://agent.${domain}/?user=${encodedUserData}`, "_blank");
  };

  const goToChat = (chat) => {
    const loginData = localStorage.getItem("login");
    if (!loginData || !brandNumber) return;

    const { token, user } = JSON.parse(loginData);
    const userData = {
      data: {
        permission: '{ "add": 1, "update": 1, "delete": 1 }',
        success: true,
        user_type: "admin",
        brand_number: brandNumber,
        user_id: user.userId,
        parent_id: user.userId,
        parent_token: token,
        name: user.name,
        email: user.username,
        token: token,
        mobile: user.mobile,
        authkey_parent: user.authkey_parent,
      },
    };

    const encodedUserData = encodeURIComponent(JSON.stringify(userData));
    const domain = getAuthkeyDomain();
    window.open(
      `https://agent.${domain}/?user=${encodedUserData}&chat_id=${chat.id}`,
      "_blank"
    );
  };

  const formatTime = (isoString) => {
    if (!isoString) return "-";
    const date = new Date(isoString);
    return date.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  return (
    <div
      style={{
        backgroundColor: "#fff",
        borderRadius: "8px",
        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        padding: "12px",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "12px",
          flexWrap: "wrap",
          gap: "6px",
        }}
      >
        <h6 style={{ margin: 0 }}>
          <strong>Live Chat Report</strong>
        </h6>
        <button
          onClick={() => {
             handleUserLog("" ,"agent_dashboard_redirect", "agent_pannel", "live chat button click from dashboard", "dashboard", "" , "");
            goToAgentDashboard();
          }}
          style={{
            backgroundColor: "#28a745",
            color: "#fff",
            border: "none",
            padding: "5px 10px",
            borderRadius: "6px",
            cursor: "pointer",
            fontSize: "0.85rem",
            display: "flex",
            alignItems: "center",
            gap: "5px",
          }}
        >
          <FontAwesomeIcon icon={faComments} /> View Live Chat
        </button>
      </div>

      {loading ? (
        <p>Loading chats...</p>
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : chatData.length === 0 ? (
        <p>No chats found</p>
      ) : (
        <>
          <div className="table-responsive-mobile">
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontSize: "0.85rem",
                tableLayout: "fixed",
              }}
            >
              <thead>
                <tr
                  style={{
                    backgroundColor: "#f8f9fa",
                    borderBottom: "2px solid #dee2e6",
                    textAlign: "left",
                  }}
                >
                  <th style={{ padding: "10px", color: "#495057" }}>Customer</th>
                  <th style={{ padding: "10px", color: "#495057" }}>Agent</th>
                  <th style={{ padding: "10px", color: "#495057" }}>Status</th>
                  <th style={{ padding: "10px", color: "#495057" }}>Message</th>
                  <th style={{ padding: "10px", color: "#495057" }}>Time</th>
                  <th style={{ padding: "10px", color: "#495057" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {chatData.map((chat, index) => (
                  <tr
                    key={chat.id}
                    style={{
                      backgroundColor: index % 2 === 0 ? "#ffffff" : "#f8f9fa",
                      borderBottom: "1px solid #dee2e6",
                    }}
                  >
                    <td
                      style={{
                        padding: "10px",
                        color: "#007bff",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "120px",
                      }}
                      title={chat.name || chat.mobile}
                    >
                      {chat.name || chat.mobile}
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "120px",
                      }}
                      title={chat.agent_name || "Unassigned"}
                    >
                      {chat.agent_name || "Unassigned"}
                    </td>
                    <td style={{ padding: "10px" }}>
                      <span
                        style={{
                          backgroundColor:
                            chat.status === 1 ? "#d4edda" : "#f8d7da",
                          color: chat.status === 1 ? "#155724" : "#721c24",
                          padding: "3px 8px",
                          borderRadius: "12px",
                          fontSize: "0.75rem",
                          fontWeight: "500",
                        }}
                      >
                        {chat.status === 1 ? "Active" : "Inactive"}
                      </span>
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        color: "red",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        maxWidth: "180px",
                      }}
                      title={chat.content}
                    >
                      {chat.content}
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        color: "#6c757d",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {formatTime(chat.created)}
                    </td>
                    <td
                      style={{
                        padding: "10px",
                        color: "#007bff",
                        cursor: "pointer",
                        fontWeight: "500",
                      }}
                      onClick={() => goToChat(chat)}
                    >
                      View
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Media query for mobile */}
          <style>
            {`
              .table-responsive-mobile {
                overflow-x: visible;
              }
              @media (max-width: 768px) {
                .table-responsive-mobile {
                  overflow-x: auto;
                }
                table {
                  table-layout: auto;
                  min-width: 600px;
                }
                td, th {
                  white-space: nowrap;
                  padding: 8px;
                }
              }
            `}
          </style>
        </>
      )}
    </div>
  );
};

export default LiveChatReport;
